import React, { Component } from "react";
import Modal from "react-modal";
import { Redirect } from "react-router-dom";
import axios from "axios";
import { withAlert } from "react-alert";
import moment from "moment-jalaali";
import "imrc-datetime-picker/dist/imrc-datetime-picker.css";
import { DatetimePickerTrigger } from "imrc-datetime-picker";
import TimePicker from "rc-time-picker";
import "rc-time-picker/assets/index.css";
import { config } from "../../config";
import Loading from "../Loading";
import * as io from "socket.io-client";
import { messaging } from "../../init-fcm";
import {
  getMapLib,
  createMapInstance,
  isNeshan,
  toPersianDigits,
  formatPersianDuration,
  formatCoordinate,
  formatPersianDateTime,
  isStopPoint,
  getStopPointContent as generateStopPointContent,
  getStartPointContent as generateStartPointContent,
  getDestinationPointContent as generateDestinationPointContent,
  getLocPointContent as generateLocPointContent,
} from "../../utils/mapHelper";

const nmp_mapboxgl = getMapLib();
Modal.setAppElement(document.body);

moment.loadPersian({
  dialect: "persian-modern",
  usePersianDigits: true,
});

let socket = false;
let map;
let markers = [];
let marker;
let infoPopup;
let stopInfoPopup;
let locInfoPopup;
let contentString;
let array = [];
let arr = [];
let bounds = new nmp_mapboxgl.LngLatBounds()
let loc;

let TimeOut;

const dateFormat = "YYYY-MM-DD HH:mm:00";

let locReportPolyline;
let locReportMarker;
let locItem = 0;
let timeOutAnimation;
let moveTimeOut;
let startPoint;
let destinationPoint;
let stopPoints = [];
let arrayNewLinePath = [];
let newLine;
let locPoint;
let locPoints = [];

class MainMap extends Component {
  constructor(props) {
    super(props);

    const defaultMoment = moment();

    this.state = {
      data: [],
      socket: false,
      signout: false,
      trackerListIsOpen: false,
      trackerList: [],
      trackerChecked: [],
      mapTypesListIsOpen: false,
      mapType: isNeshan ? "neshanVector" : "osm",
      isInfoBoxOpen: 0,
      isTimeSelectOpen: false,
      isAnimationSpeedOpen: false,
      from: defaultMoment,
      to: defaultMoment,
      value: 3,
      trackerData: {},
      locReportToken: "",
      showPlayIcon: false,
      locReport: [],
      showStopDiv: false,
      currentLocReport: [],
      isPause: false,
      loading: true,
      isExpiredTracersOpen: false,
      selectedTime: 0,
      socketFlag: 2,
      expiredTracers: [],
      isStopPointOpen: false,
      isStartPointOpen: false,
      isDestinationPointOpen: false,
      locReportOnMap: false,
      showPoints: false,
      isLocPointOpen: false,
      timeOut: 0,
    };

    this.currentStopPointKey = null;
    this.currentOpenPopup = null;
    this.socket = io("https://socket.irgogps.com");

    this.onScriptLoad = this.onScriptLoad.bind(this);
    this.closeTrackerList = this.closeTrackerList.bind(this);
    this.handleCheckbox = this.handleCheckbox.bind(this);
    this.closeMapTypsList = this.closeMapTypsList.bind(this);
    this.openInfo = this.openInfo.bind(this);
    this.closeTimeSelect = this.closeTimeSelect.bind(this);
    this.closeAnimationSpeed = this.closeAnimationSpeed.bind(this);
    this.handleRangeSpeed = this.handleRangeSpeed.bind(this);
    this.handleFromDate = this.handleFromDate.bind(this);
    this.handleToDate = this.handleToDate.bind(this);
    this.reloadMap = this.reloadMap.bind(this);
    this.openSelectSpeed = this.openSelectSpeed.bind(this);
    this.getLocationReport = this.getLocationReport.bind(this);
    this.checkLocationReport = this.checkLocationReport.bind(this);
    this.startAnimate = this.startAnimate.bind(this);
    this.stopAnimate = this.stopAnimate.bind(this);
    this.removepolyline = this.removepolyline.bind(this);
    this.generateMarkerIconUrl = this.generateMarkerIconUrl.bind(this);
    this.roundRotationNumber = this.roundRotationNumber.bind(this);
    this.moveMarker = this.moveMarker.bind(this);
    this.socketUpdateData = this.socketUpdateData.bind(this);
    this.authSocket = this.authSocket.bind(this);
    this.closeCurrentPopup = this.closeCurrentPopup.bind(this);
    this.toggleMarkerPopup = this.toggleMarkerPopup.bind(this);
    this.openStopPointInfo = this.openStopPointInfo.bind(this);
    this.openStartPointInfo = this.openStartPointInfo.bind(this);
    this.openDestinationPointInfo = this.openDestinationPointInfo.bind(this);
    this.getStopPointContent = this.getStopPointContent.bind(this);
    this.getLocPointContent = this.getLocPointContent.bind(this);
    this.getStartPointContent = this.getStartPointContent.bind(this);
    this.getDestinationPointContent = this.getDestinationPointContent.bind(this);
    this.getTrackers = this.getTrackers.bind(this);
    this.zoomIn = this.zoomIn.bind(this);
    this.zoomOut = this.zoomOut.bind(this);
  }

  getTrackers() {
    let req = {
      method: "get",
      url: config.baseUrl + "api/v2/clients/tracers",
      headers: {
        Authorization: "Bearer " + config.token,
      },
    };

    axios(req)
      .then((resp) => {
        if (resp.data.status === 1) {
          arr = [];
          array = [];
          markers = [];

          let data = resp.data.data;
          let expireData = [];
          for (let item of data) {
            if (!item.last_lat || !item.last_lng) {
              item.last_lat = 0;
              item.last_lng = 0;
            }
          }
          this.setState({
            data: data,
          });
          for (let i in data) {
            loc = new nmp_mapboxgl.LngLat(
                data[i].last_lng,
                data[i].last_lat,
            )
            bounds.extend(loc)

            let markerEl = document.createElement('img');
            markerEl.src = this.generateMarkerIconUrl(
                data[i].usage.code,
                data[i].last_course,
                data[i].data_color,
                data[i].is_expired
            );
            markerEl.style.width = '40px';
            markerEl.style.height = '40px';

            marker = new nmp_mapboxgl.Marker({ element: markerEl, anchor: 'top' })
                .setLngLat([
                    parseFloat(data[i].last_lng),
                    parseFloat(data[i].last_lat),
                ])
                .addTo(map);
            marker.markerId = data[i].id;
            marker.markerTitle = data[i].title;
            marker.isExpired = data[i].is_expired;

            if (data[i].last_lat === 0 || data[i].last_lng === 0) {
              marker.remove()
            }
            markerEl.style.cursor = 'pointer';

            const trackerItem = data[i];
            const markerRef = marker;
            markerEl.addEventListener('click', () => {
              console.log(trackerItem)
              this.openInfo(trackerItem, i);
            });

            if (moment(data[i].expires_at).diff(moment(), "days") < 5) {
              expireData.push(data[i]);
            }

            arr.push(data[i].id);
            array.push([data[i].id, data[i].title]);
            markers.push(marker);
          }

          if (map && !bounds.isEmpty()) {
            map.fitBounds(bounds, { padding: 100, maxZoom: 13, maxDuration: 300 });
          }

          this.setState({
            trackerList: array,
            trackerChecked: arr,
            expiredTracers: expireData,
            loading: false,
          });
          if (expireData.length > 0) {
            this.setState({ isExpiredTracersOpen: true });
          }

          let selectetTrackers =
            window.localStorage.getItem("SelectedTrackers");

          if (selectetTrackers != null && selectetTrackers !== "") {
            selectetTrackers = selectetTrackers
              .split(",")
              .map((x) => Number(x));

            for (let item of arr) {
              if (!selectetTrackers.includes(item)) {
                setTimeout(() => {
                  this.handleCheckbox(item);
                }, 500);
              }
            }
          }
        }
      })
      .catch((err) => {
        if (
          err.response &&
          (err.response.status === 401 || err.response.status === 403)
        ) {
          localStorage.setItem("isLogedin", false);
          localStorage.setItem("role", "");
          this.setState({ signout: true, loading: false });
          this.socket.disconnect();
        }
      })
      .finally(() => {
        this.setState({ loading: false })
      });
  }

  onScriptLoad(mapType) {
    this.setState({ data: [], socketFlag: 2 });

    if (socket === true) {
      this.socket.disconnect();
      this.authSocket();
      this.socketUpdateData();
    }

    array = [];

    const effectiveMapType = mapType || this.state.mapType;

    map = createMapInstance({
      container: document.getElementById("myMap"),
      mapType: effectiveMapType,
      center: [46.270212, 38.0843038],
      zoom: 5,
    });

    // map.mapTypes.set(
    //   "ir-map",
    //   new window.google.maps.ImageMapType({
    //     getTileUrl: function (coord, zoom) {
    //       return (
    //         "https://map.ir/shiveh/xyz/1.0.0/Shiveh:Shiveh@EPSG:3857@png/" +
    //         zoom +
    //         "/" +
    //         coord.x +
    //         "/" +
    //         coord.y +
    //         ".png?x-api-key=" + map_token
    //       );
    //     },
    //     tileSize: new window.google.maps.Size(256, 256),
    //     name: "ir-map",
    //     maxZoom: 18,
    //   })
    // );

    this.getTrackers();
  }
  authSocket() {
    this.socket.emit("authenticate", {
      token:
        window.sessionStorage.getItem("token") ||
        window.localStorage.getItem("token"),
    });
  }
  socketUpdateData() {
    bounds = new nmp_mapboxgl.LngLatBounds();

    this.authSocket();

    this.socket.on("authenticate", (data) => {
      if (!data.status) {
        this.authSocket();
        this.setState({ socketFlag: 0 });
      } else {
        if (this.state.socketFlag === 0 || this.state.socketFlag === 2) {
          this.props.alert.success("ارتباط با سرور بر قرار شد.");
        }
        socket = true;
        this.setState({ socketFlag: 1 });
      }
    });
    this.socket.on("connect_error", (error) => {
      if (this.state.socketFlag === 1 || this.state.socketFlag === 2) {
        this.props.alert.error(
          "عدم برقراری ارتباط با سرور، در حال اتصال مجدد..."
        );
      }
      this.authSocket();
      this.setState({ socketFlag: 0 });
    });

    this.socket.on("connect_timeout", (timeout) => {
      if (this.state.socketFlag === 1 || this.state.socketFlag === 2) {
        this.props.alert.error(
          "عدم برقراری ارتباط با سرور، در حال اتصال مجدد..."
        );
      }
      this.authSocket();
      this.setState({ socketFlag: 0 });
    });

    this.socket.on("lastLocations", (data) => {
      let tracers = this.state.data;
      let tracer = this.state.trackerData;
      let usageCode = "";
      for (let item of data) {
        for (let i of tracers) {
          if (item.id === i.id) {
            usageCode = i.usage.code;
            if (item.lat !== i.last_lat) {
              i.last_lat = item.lat;
            }
            if (item.lng !== i.last_lng) {
              i.last_lng = item.lng;
            }
            if (item.course !== i.last_course) {
              i.last_course = item.course;
            }
            if (item.data_color !== i.data_color) {
              i.data_color = item.data_color;
            }
            if (item.sat_count !== i.sat_count) {
              i.sat_count = item.sat_count;
            }
            if (item.sent_at !== i.last_sent) {
              i.last_sent = item.sent_at;
            }
            if (item.acc !== i.last_acc) {
              i.last_acc = item.acc;
            }
            if (item.speed !== i.last_speed) {
              i.last_speed = item.speed;
            }
          }
          if (!this.state.locReportOnMap) {
            loc = new nmp_mapboxgl.LngLat(item.lng, item.lat)
            bounds.extend(loc);
          }
        }
        for (let m of markers) {
          if (item.id === m.markerId) {
            if (item.lat && item.lng) {
              if (
                parseFloat(item.lat) !== m.getLngLat().lat ||
                parseFloat(item.lng) !== m.getLngLat().lng
              ) {
                m.setLngLat([parseFloat(item.lng), parseFloat(item.lat)]);
                let el = m.getElement();
                if (el) {
                  let img = el.tagName === 'IMG' ? el : el.querySelector('img');
                  if (img) {
                    img.src = this.generateMarkerIconUrl(
                      usageCode,
                      item.course,
                      item.data_color,
                      m.isExpired
                    );
                  }
                }
              }
            }
          }
        }
        if (item.id === this.state.isInfoBoxOpen) {
          if (item.lat && item.lng) {
            if (item.lat !== tracer.last_lat) {
              tracer.last_lat = item.lat;
            }
            if (item.lng !== tracer.last_lng) {
              tracer.last_lng = item.lng;
            }
            if (item.course !== tracer.last_course) {
              tracer.last_course = item.course;
            }
            if (item.data_color !== tracer.data_color) {
              tracer.data_color = item.data_color;
            }
            if (item.sat_count !== tracer.sat_count) {
              tracer.sat_count = item.sat_count;
            }
            if (item.sent_at !== tracer.last_sent) {
              tracer.last_sent = item.sent_at;
            }
            if (item.acc !== tracer.last_acc) {
              tracer.last_acc = item.acc;
            }
            if (item.speed !== tracer.last_speed) {
              tracer.last_speed = item.speed;
            }
            this.setState({ trackerData: tracer });
          }
        }
      }
      this.setState({ data: tracers, socket: true });
    });

    this.socket.on("heartbeat", (data) => {
      this.socket.emit("heartbeat", data);
    });
  }
  generateMarkerIconUrl(markerType, rotation, color, isExpired) {
    const validTypes = ["animal", "bus", "car", "motorcycle", "object", "personal", "truck"];
    const validColors = ["gray", "green", "orange", "red"];
    const type = validTypes.includes(markerType) ? markerType : "car";
    let col = isExpired === 1 ? "gray" : color;
    if (!validColors.includes(col)) {
      col = "green";
    }
    const round = this.roundRotationNumber(rotation);
    try {
      return require(`../../image/markers/${type}/${col}/${round}.png`);
    } catch (e) {
      return require(`../../image/markers/car/green/1.png`);
    }
  }
  roundRotationNumber(rotation) {
    const r = typeof rotation === "number" && !isNaN(rotation) ? rotation : 0;
    const remained = r / 10;
    let round = Math.round(remained);

    if (round > 36) {
      round = 36;
    } else if (round <= 0) {
      round = 1;
    }

    return round;
  }
  handleSelectTime(period) {
    let newDate = moment();
    if (period === 1) {
      newDate.subtract(1, "hours");
    } else if (period === 6) {
      newDate.subtract(6, "hours");
    } else if (period === 12) {
      newDate.subtract(12, "hours");
    } else if (period === 24) {
      newDate.subtract(24, "hours");
    }
    this.setState({ selectedTime: period, from: newDate, to: moment() });
  }
  closeTrackerList() {
    this.setState({ trackerListIsOpen: false });
  }
  handleCheckbox(id) {
    let array = this.state.trackerChecked;

    if (array.includes(id)) {
      for (let i in markers) {
        if (markers[i].markerId === id) {
          markers[i].remove();
        }
      }
      let index = array.indexOf(id);
      if (index > -1) {
        array.splice(index, 1);
      }
    } else {
      array.push(id);
      for (let i in markers) {
        if (markers[i].markerId === id) {
          markers[i].addTo(map);
        }
      }
    }
    this.setState({ trackerChecked: array, isInfoBoxOpen: 0 });

    clearTimeout(TimeOut);
    TimeOut = setTimeout(() => {
      localStorage.setItem("SelectedTrackers", array);
    }, 1000);

    let bnds = new nmp_mapboxgl.LngLatBounds();
    for (let i in markers) {
      if (array.includes(markers[i].markerId)) {
        bnds.extend(markers[i].getLngLat());
      }
    }
    if (map && !bnds.isEmpty()) {
      map.fitBounds(bnds, { padding: 100, maxZoom: 13, maxDuration: 300 });
    }
  }
  chanegMapType(type) {
    this.onScriptLoad(type);
    this.setState({
      mapType: type,
      isInfoBoxOpen: 0,
      showPlayIcon: false,
      showStopDiv: false,
    });
    this.removepolyline();
  }
  closeMapTypsList() {
    this.setState({ mapTypesListIsOpen: false });
  }
  openInfo(data, item) {
    contentString =
      '<div id="content">' + "<p>" + array[item][1] + "</p>" + "</div>";

    if (this.state.isInfoBoxOpen === data.id) {
      this.setState({ isInfoBoxOpen: 0, trackerData: data });
      if (infoPopup) infoPopup.remove();
    } else {
      this.setState({ isInfoBoxOpen: data.id, trackerData: data });
      if (infoPopup) infoPopup.remove();

      const trackerLocation = [
        parseFloat(data.last_lng),
        parseFloat(data.last_lat),
      ];

      infoPopup = new nmp_mapboxgl.Popup({ offset: 25 })
          .setHTML(contentString)
          .setLngLat(trackerLocation)
          .addTo(map);

      if (map) {
        const currentZoom = typeof map.getZoom === "function" ? map.getZoom() : 13;
        const targetZoom = Math.min(Math.max(currentZoom + 3, 15), 18);

        if (typeof map.flyTo === "function") {
          map.flyTo({ center: trackerLocation, zoom: targetZoom, duration: 600 });
        } else {
          map.setCenter(trackerLocation);
          map.setZoom(targetZoom);
        }
      }
    }

    return contentString
  }
  closeTimeSelect() {
    this.setState({ isTimeSelectOpen: false });
  }
  closeAnimationSpeed() {
    this.setState({ isAnimationSpeedOpen: false });
    this.removepolyline();
  }
  handleRangeSpeed(e) {
    this.setState({ value: e.target.value });
  }
  handleFromDate(moment) {
    this.setState({ from: moment });
  }
  handleToDate(moment) {
    this.setState({ to: moment });
  }

  reloadMap() {
    this.setState({ isInfoBoxOpen: 0, showPlayIcon: false });

    this.onScriptLoad(this.state.mapType);

    if (locReportPolyline != null) {
      this.removepolyline();
    }
  }

  zoomIn() {
    if (map) {
      map.zoomIn();
    }
  }

  zoomOut() {
    if (map) {
      map.zoomOut();
    }
  }

  openSelectSpeed() {
    this.setState({ isAnimationSpeedOpen: true, isTimeSelectOpen: false });
  }
  getLocationReport() {
    this.setState({ loading: true });

    let start = this.state.from.utc().locale("en").format(dateFormat);
    let end = this.state.to.utc().locale("en").format(dateFormat);

    let req = {
      method: "get",
      url:
        config.baseUrl +
        "api/v2/clients/reports/location/request?id=" +
        this.state.isInfoBoxOpen +
        "&start_date=" +
        start +
        "&end_date=" +
        end,
      headers: {
        Authorization: "Bearer " + config.token,
      },
    };
    axios(req)
      .then((resp) => {
        if (resp.data.status === 1) {
          this.setState({ locReportToken: resp.data.data.token, timeOut: 0 });
          this.locReportCheckTimeout = setTimeout(this.checkLocationReport, 2000);
        } else {
          this.setState({ loading: false });
          if (this.props.alert) {
            this.props.alert.error(resp.data.message || "خطا در درخواست سابقه موقعیت");
          }
        }
      })
      .catch((err) => {
        this.setState({ loading: false });
        if (this.props.alert) {
          this.props.alert.error("خطا در برقراری ارتباط با سرور");
        }
      });

    this.state.from.local().locale("fa");
    this.state.to.local().locale("fa");
  }
  checkLocationReport() {
    let check = {
      method: "get",
      url:
        config.baseUrl +
        "api/v2/clients/reports/location/check/" +
        this.state.locReportToken,
      headers: {
        Authorization: "Bearer " + config.token,
      },
    };

    axios(check)
      .then((resp) => {
        if (resp.data.requestStatus === 3) {
          this.setState({ locReportOnMap: true });
          const traces = (resp.data.data && resp.data.data.traces) || [];
          if (traces.length > 0) {
            // Clean up any previously drawn report markers or lines first
            this.closeCurrentPopup();
            if (locReportMarker) {
              locReportMarker.remove();
              locReportMarker = null;
            }
            if (startPoint) {
              if (typeof startPoint.getPopup === "function" && startPoint.getPopup()) {
                startPoint.getPopup().remove();
              }
              startPoint.remove();
              startPoint = null;
            }
            if (destinationPoint) {
              if (typeof destinationPoint.getPopup === "function" && destinationPoint.getPopup()) {
                destinationPoint.getPopup().remove();
              }
              destinationPoint.remove();
              destinationPoint = null;
            }
            for (let i in stopPoints) {
              if (stopPoints[i]) {
                if (typeof stopPoints[i].getPopup === "function" && stopPoints[i].getPopup()) {
                  stopPoints[i].getPopup().remove();
                }
                stopPoints[i].remove();
              }
            }
            stopPoints = [];
            for (let i in locPoints) {
              if (locPoints[i]) {
                if (typeof locPoints[i].getPopup === "function" && locPoints[i].getPopup()) {
                  locPoints[i].getPopup().remove();
                }
                locPoints[i].remove();
              }
            }
            locPoints = [];
            if (infoPopup) {
              infoPopup.remove();
              infoPopup = null;
            }
            if (stopInfoPopup) {
              stopInfoPopup.remove();
              stopInfoPopup = null;
            }
            if (locInfoPopup) {
              locInfoPopup.remove();
              locInfoPopup = null;
            }

            const coordinates = traces
              .filter(t => t && !isNaN(parseFloat(t.lng)) && !isNaN(parseFloat(t.lat)))
              .map(t => [parseFloat(t.lng), parseFloat(t.lat)]);

            // Dashed polyline for full route
            locReportPolyline = 'locReportRoute';
            if (map) {
              if (map.getLayer('locReportRoute')) map.removeLayer('locReportRoute');
              if (map.getSource('locReportRoute')) map.removeSource('locReportRoute');

              map.addSource('locReportRoute', {
                type: 'geojson',
                data: coordinates.length >= 2 ? {
                  type: 'Feature',
                  geometry: {
                    type: 'LineString',
                    coordinates: coordinates
                  }
                } : {
                  type: 'FeatureCollection',
                  features: []
                }
              });
              map.addLayer({
                id: 'locReportRoute',
                type: 'line',
                source: 'locReportRoute',
                paint: {
                  'line-color': '#3D8DF9',
                  'line-width': 2,
                  'line-dasharray': [2, 4]
                }
              });

              // Solid polyline for animation path
              arrayNewLinePath = [];
              newLine = 'newLine';
              if (map.getLayer('newLine')) map.removeLayer('newLine');
              if (map.getSource('newLine')) map.removeSource('newLine');

              map.addSource('newLine', {
                type: 'geojson',
                data: {
                  type: 'FeatureCollection',
                  features: []
                }
              });
              map.addLayer({
                id: 'newLine',
                type: 'line',
                source: 'newLine',
                paint: {
                  'line-color': '#3D8DF9',
                  'line-width': 3
                }
              });
            }

            let data = traces;
            let stopData = [];
            for (let i = 0; i < data.length; i++) {
              const item = data[i];
              const itemLng = parseFloat(item.lng);
              const itemLat = parseFloat(item.lat);
              if (isNaN(itemLng) || isNaN(itemLat)) continue;

              const isStop = isStopPoint(item);
              const isStart = item.is_start === 1 || item.is_start === true || item.is_start === "1";
              const isEnd = item.is_end === 1 || item.is_end === true || item.is_end === "1";

              if (this.state.showPoints && map) {
                let svgNS = "http://www.w3.org/2000/svg";
                let svg = document.createElementNS(svgNS, "svg");
                svg.setAttribute("width", "16");
                svg.setAttribute("height", "16");
                svg.setAttribute("viewBox", "0 0 32 32");
                svg.style.transform = `rotate(${(item.course || 0) - 90}deg)`;
                svg.style.cursor = "pointer";
                svg.style.pointerEvents = "auto";
                let pathEl = document.createElementNS(svgNS, "path");
                pathEl.setAttribute("d", "m24.291,14.276l-9.586,-9.586c-0.878,-0.878 -2.317,-0.878 -3.195,0l-0.8,0.8c-0.878,0.877 -0.878,2.316 0,3.194l7.314,7.316l-7.315,7.315c-0.878,0.878 -0.878,2.317 0,3.194l0.8,0.8c0.878,0.879 2.317,0.879 3.195,0l9.586,-9.587c0.472,-0.471 0.682,-1.103 0.647,-1.723c0.036,-0.619 -0.174,-1.251 -0.646,-1.723z");
                pathEl.setAttribute("fill", "#3d8df9");
                svg.appendChild(pathEl);
                locPoint = new nmp_mapboxgl.Marker({ element: svg })
                  .setLngLat([itemLng, itemLat])
                  .addTo(map);

                const pointContent = isStop
                  ? this.getStopPointContent(item)
                  : this.getLocPointContent(item);
                const pointPopup = new nmp_mapboxgl.Popup({
                  offset: 20,
                  closeButton: true,
                  closeOnClick: true,
                }).setHTML(pointContent);
                pointPopup.on("close", () => {
                  if (this.currentOpenPopup === pointPopup) {
                    this.currentOpenPopup = null;
                  }
                });
                locPoint.setPopup(pointPopup);

                const curPoint = locPoint;
                svg.addEventListener("click", (e) => {
                  if (e && typeof e.stopPropagation === "function") e.stopPropagation();
                  this.openLocPointInfo(item, curPoint);
                });
                locPoints.push(locPoint);
              }
              if (
                isStop &&
                !isStart &&
                !isEnd
              ) {
                stopData.push(item);
              }
              if (isStart && map) {
                let startEl = document.createElement("img");
                startEl.src = require("../../image/beginning.png");
                startEl.style.width = "20px";
                startEl.style.height = "20px";
                startEl.style.cursor = "pointer";
                startEl.style.pointerEvents = "auto";
                startEl.setAttribute("draggable", "false");
                startPoint = new nmp_mapboxgl.Marker({ element: startEl })
                  .setLngLat([itemLng, itemLat])
                  .addTo(map);

                const startPopup = new nmp_mapboxgl.Popup({
                  offset: 20,
                  closeButton: true,
                  closeOnClick: true,
                }).setHTML(this.getStartPointContent(item));
                startPopup.on("close", () => {
                  if (this.currentOpenPopup === startPopup) {
                    this.currentOpenPopup = null;
                  }
                });
                startPoint.setPopup(startPopup);

                startEl.addEventListener("click", (e) => {
                  if (e && typeof e.stopPropagation === "function") e.stopPropagation();
                  this.openStartPointInfo(item);
                });
              }
              if (isEnd && map) {
                let destEl = document.createElement("img");
                destEl.src = require("../../image/destination.png");
                destEl.style.width = "30px";
                destEl.style.height = "30px";
                destEl.style.cursor = "pointer";
                destEl.style.pointerEvents = "auto";
                destEl.setAttribute("draggable", "false");
                destinationPoint = new nmp_mapboxgl.Marker({ element: destEl })
                  .setLngLat([itemLng, itemLat])
                  .addTo(map);

                const destPopup = new nmp_mapboxgl.Popup({
                  offset: 25,
                  closeButton: true,
                  closeOnClick: true,
                }).setHTML(this.getDestinationPointContent(item));
                destPopup.on("close", () => {
                  if (this.currentOpenPopup === destPopup) {
                    this.currentOpenPopup = null;
                  }
                });
                destinationPoint.setPopup(destPopup);

                destEl.addEventListener("click", (e) => {
                  if (e && typeof e.stopPropagation === "function") e.stopPropagation();
                  this.openDestinationPointInfo(item);
                });
              }
            }
            if (map) {
              for (let i = 0; i < stopData.length; i++) {
                const sItem = stopData[i];
                const sLng = parseFloat(sItem.lng);
                const sLat = parseFloat(sItem.lat);
                if (isNaN(sLng) || isNaN(sLat)) continue;

                let stopEl = document.createElement("img");
                stopEl.src = require("../../image/stop.png");
                stopEl.style.width = "30px";
                stopEl.style.height = "30px";
                stopEl.style.cursor = "pointer";
                stopEl.style.pointerEvents = "auto";
                stopEl.setAttribute("draggable", "false");

                const stopMarker = new nmp_mapboxgl.Marker({ element: stopEl })
                  .setLngLat([sLng, sLat])
                  .addTo(map);

                const stopPopup = new nmp_mapboxgl.Popup({
                  offset: 25,
                  closeButton: true,
                  closeOnClick: true,
                }).setHTML(this.getStopPointContent(sItem));
                stopPopup.on("close", () => {
                  if (this.currentOpenPopup === stopPopup) {
                    this.currentOpenPopup = null;
                  }
                });
                stopMarker.setPopup(stopPopup);

                const curStop = stopMarker;
                stopEl.addEventListener("click", (e) => {
                  if (e && typeof e.stopPropagation === "function") e.stopPropagation();
                  this.openStopPointInfo(sItem, curStop);
                });
                stopPoints.push(stopMarker);
              }
            }

            this.setState({
              isInfoBoxOpen: 0,
              showPlayIcon: true,
              isTimeSelectOpen: false,
              locReport: traces,
              currentLocReport: traces[0] || {},
              loading: false,
              isReportOnMap: true,
            });

            let usageCode =
              (this.state.trackerData &&
                this.state.trackerData.usage &&
                this.state.trackerData.usage.code) ||
              "car";
            let color =
              (this.state.trackerData && this.state.trackerData.data_color) ||
              "green";
            let course = (traces[0] && traces[0].course) || 0;

            let reportEl = document.createElement('img');
            reportEl.src = this.generateMarkerIconUrl(
              usageCode,
              course,
              color
            );
            reportEl.style.width = '40px';
            reportEl.style.height = '40px';
            if (map) {
              locReportMarker = new nmp_mapboxgl.Marker({ element: reportEl })
                .setLngLat([parseFloat(data[0].lng), parseFloat(data[0].lat)])
                .addTo(map);

              if (coordinates.length > 0) {
                let routeBounds = new nmp_mapboxgl.LngLatBounds();
                coordinates.forEach(coord => routeBounds.extend(coord));
                map.fitBounds(routeBounds, { padding: 80, maxZoom: 13, maxDuration: 600 });
              } else {
                map.panTo([parseFloat(traces[0].lng), parseFloat(traces[0].lat)]);
                map.setZoom(13);
              }
            }
          } else {
            this.setState({
              isInfoBoxOpen: 0,
              isTimeSelectOpen: false,
              loading: false,
            });
            this.props.alert.error(
              "در بازه زمانی انتخاب شده سابقه ای ثبت نشده است."
            );
          }
        } else {
          if (this.state.timeOut <= 120000) {
            this.locReportCheckTimeout = setTimeout(this.checkLocationReport, 2000);
            this.setState({ timeOut: this.state.timeOut + 2000 });
          } else {
            this.props.alert.error(
              "مشکلی در پاسخ دهی سرور آمد، لطفا دوباره امتحان کنید."
            );
            this.setState({ timeOut: 0, loading: false });
          }
        }
      })
      .catch((err) => {
        this.setState({ loading: false });
      });
  }
  getStopPointContent(data) {
    return generateStopPointContent(data, moment);
  }

  getLocPointContent(data) {
    return generateLocPointContent(data, moment);
  }

  getStartPointContent(data) {
    return generateStartPointContent(data, moment);
  }

  getDestinationPointContent(data) {
    return generateDestinationPointContent(data, moment);
  }

  closeCurrentPopup() {
    if (this.currentOpenPopup) {
      if (typeof this.currentOpenPopup.remove === "function") {
        this.currentOpenPopup.remove();
      }
      this.currentOpenPopup = null;
    }
  }

  toggleMarkerPopup(marker) {
    if (!marker) return;
    const popup = marker.getPopup();
    if (!popup) return;

    if (popup.isOpen()) {
      popup.remove();
      this.currentOpenPopup = null;
    } else {
      this.closeCurrentPopup();
      popup.addTo(map);
      this.currentOpenPopup = popup;
    }
  }

  openStopPointInfo(data, item) {
    if (!data) return;
    let pt = null;
    if (item && typeof item.getPopup === "function") {
      pt = item;
    } else if (typeof item === "number" && stopPoints[item]) {
      pt = stopPoints[item];
    }
    if (pt) {
      this.toggleMarkerPopup(pt);
      return;
    }

    this.closeCurrentPopup();

    let latVal = data.lat !== undefined && data.lat !== null ? data.lat : data.latitude;
    let lngVal = data.lng !== undefined && data.lng !== null ? data.lng : (data.lon !== undefined ? data.lon : data.longitude);
    const lngLat = [parseFloat(lngVal), parseFloat(latVal)];

    if (map && !isNaN(lngLat[0]) && !isNaN(lngLat[1])) {
      const popup = new nmp_mapboxgl.Popup({ offset: 25, closeButton: true, closeOnClick: true })
        .setHTML(this.getStopPointContent(data))
        .setLngLat(lngLat);
      popup.on("close", () => {
        if (this.currentOpenPopup === popup) {
          this.currentOpenPopup = null;
        }
      });
      popup.addTo(map);
      this.currentOpenPopup = popup;
    }
  }

  openLocPointInfo(data, item) {
    if (isStopPoint(data)) {
      this.openStopPointInfo(data, item);
      return;
    }
    let pt = null;
    if (item && typeof item.getPopup === "function") {
      pt = item;
    } else if (typeof item === "number" && locPoints[item]) {
      pt = locPoints[item];
    }
    if (pt) {
      this.toggleMarkerPopup(pt);
      return;
    }

    this.closeCurrentPopup();

    let lngLat = [parseFloat(data.lng), parseFloat(data.lat)];
    if (map && !isNaN(lngLat[0]) && !isNaN(lngLat[1])) {
      const popup = new nmp_mapboxgl.Popup({ offset: 20, closeButton: true, closeOnClick: true })
        .setHTML(this.getLocPointContent(data))
        .setLngLat(lngLat);
      popup.on("close", () => {
        if (this.currentOpenPopup === popup) {
          this.currentOpenPopup = null;
        }
      });
      popup.addTo(map);
      this.currentOpenPopup = popup;
    }
  }

  openStartPointInfo(data) {
    if (startPoint && typeof startPoint.getPopup === "function") {
      this.toggleMarkerPopup(startPoint);
      return;
    }
    this.closeCurrentPopup();
    if (startPoint && map) {
      const popup = new nmp_mapboxgl.Popup({ offset: 20, closeButton: true, closeOnClick: true })
        .setHTML(this.getStartPointContent(data))
        .setLngLat(startPoint.getLngLat());
      popup.on("close", () => {
        if (this.currentOpenPopup === popup) {
          this.currentOpenPopup = null;
        }
      });
      popup.addTo(map);
      this.currentOpenPopup = popup;
    }
  }

  openDestinationPointInfo(data) {
    if (destinationPoint && typeof destinationPoint.getPopup === "function") {
      this.toggleMarkerPopup(destinationPoint);
      return;
    }
    this.closeCurrentPopup();
    if (destinationPoint && map) {
      const popup = new nmp_mapboxgl.Popup({ offset: 25, closeButton: true, closeOnClick: true })
        .setHTML(this.getDestinationPointContent(data))
        .setLngLat(destinationPoint.getLngLat());
      popup.on("close", () => {
        if (this.currentOpenPopup === popup) {
          this.currentOpenPopup = null;
        }
      });
      popup.addTo(map);
      this.currentOpenPopup = popup;
    }
  }
  startAnimate() {
    if (!this.state.locReport || this.state.locReport.length === 0 || !locReportMarker) {
      return;
    }
    if (locItem < this.state.locReport.length - 1) {
      locItem = locItem + 1;
    } else if (locItem === this.state.locReport.length - 1) {
      locItem = 0;
      arrayNewLinePath = [];
      if (map && map.getSource('newLine')) {
        map.getSource('newLine').setData({
          type: 'FeatureCollection',
          features: []
        });
      }
    }
    this.setState({
      isAnimationSpeedOpen: false,
      showStopDiv: true,
      isPause: false,
    });
    let moveToLngLat = [
      parseFloat(this.state.locReport[locItem].lng),
      parseFloat(this.state.locReport[locItem].lat)
    ];

    let speed = 1000 - (this.state.value - 1) * 100;
    if (locItem < this.state.locReport.length) {
      timeOutAnimation = setTimeout(() => {
        if (!locReportMarker) return;
        this.moveMarker(
          locReportMarker,
          speed / 100,
          locReportMarker.getLngLat(),
          moveToLngLat,
          locItem
        );
      }, speed);
      this.setState({ currentLocReport: this.state.locReport[locItem] });
    }
  }
  moveMarker(marker, t, current, moveto, item) {
    if (!marker || !current || !moveto) return;
    let el = marker.getElement();
    if (el) {
      let img = el.tagName === 'IMG' ? el : el.querySelector('img');
      if (img) {
        let usageCode =
          (this.state.trackerData &&
            this.state.trackerData.usage &&
            this.state.trackerData.usage.code) ||
          "car";
        let course = (this.state.locReport[item] && this.state.locReport[item].course) || 0;
        img.src = this.generateMarkerIconUrl(
          usageCode,
          course,
          "green"
        );
      }
    }
    if (map) {
      map.panTo(moveto);
    }

    let deltalat = (moveto[1] - current.lat) / 100;
    let deltalng = (moveto[0] - current.lng) / 100;

    for (let i = 0; i < 100; i++) {
      (function (ind) {
        moveTimeOut = setTimeout(function () {
          if (!marker) return;
          let pos = marker.getLngLat();
          if (!pos) return;
          let lat = pos.lat + deltalat;
          let lng = pos.lng + deltalng;
          marker.setLngLat([lng, lat]);
        }, t * ind);
      })(i);
    }
    arrayNewLinePath.push(moveto);
    if (map && map.getSource('newLine')) {
      if (arrayNewLinePath.length >= 2) {
        map.getSource('newLine').setData({
          type: 'Feature',
          geometry: {
            type: 'LineString',
            coordinates: arrayNewLinePath
          }
        });
      } else {
        map.getSource('newLine').setData({
          type: 'FeatureCollection',
          features: []
        });
      }
    }
    if (locItem < this.state.locReport.length - 1) {
      this.startAnimate();
    }
    if (locItem === this.state.locReport.length - 1) {
      this.setState({ isPause: true });
    }
  }
  stopAnimate() {
    locItem = locItem - 1;
    this.setState({ isPause: true });
    clearTimeout(moveTimeOut);
    clearTimeout(timeOutAnimation);
  }
  removepolyline() {
    clearTimeout(timeOutAnimation);
    clearTimeout(moveTimeOut);
    clearTimeout(this.locReportCheckTimeout);
    this.closeCurrentPopup();
    this.setState({
      showStopDiv: false,
      isPause: false,
      trackerData: this.state.trackerData || {},
      isReportOnMap: false,
    });
    if (map) {
      if (map.getLayer('locReportRoute')) map.removeLayer('locReportRoute');
      if (map.getSource('locReportRoute')) map.removeSource('locReportRoute');
      if (map.getLayer('newLine')) map.removeLayer('newLine');
      if (map.getSource('newLine')) map.removeSource('newLine');
    }
    if (locReportMarker) {
      locReportMarker.remove();
      locReportMarker = null;
    }
    for (let i in stopPoints) {
      if (stopPoints[i]) {
        if (typeof stopPoints[i].getPopup === "function" && stopPoints[i].getPopup()) {
          stopPoints[i].getPopup().remove();
        }
        stopPoints[i].remove();
      }
    }
    for (let i in locPoints) {
      if (locPoints[i]) {
        if (typeof locPoints[i].getPopup === "function" && locPoints[i].getPopup()) {
          locPoints[i].getPopup().remove();
        }
        locPoints[i].remove();
      }
    }
    if (startPoint) {
      if (typeof startPoint.getPopup === "function" && startPoint.getPopup()) {
        startPoint.getPopup().remove();
      }
      startPoint.remove();
      startPoint = null;
    }
    if (destinationPoint) {
      if (typeof destinationPoint.getPopup === "function" && destinationPoint.getPopup()) {
        destinationPoint.getPopup().remove();
      }
      destinationPoint.remove();
      destinationPoint = null;
    }
    if (infoPopup) {
      infoPopup.remove();
      infoPopup = null;
    }
    if (stopInfoPopup) {
      stopInfoPopup.remove();
      stopInfoPopup = null;
    }
    if (locInfoPopup) {
      locInfoPopup.remove();
      locInfoPopup = null;
    }
    locItem = 0;
    stopPoints = [];
    locPoints = [];
    arrayNewLinePath = [];
    locReportPolyline = null;
    newLine = null;
    this.currentStopPointKey = null;
    this.setState({
      isStopPointOpen: false,
      isLocPointOpen: false,
      isStartPointOpen: false,
      isDestinationPointOpen: false,
    });
  }
  componentWillUnmount() {
    clearTimeout(timeOutAnimation);
    clearTimeout(moveTimeOut);
    clearTimeout(this.locReportCheckTimeout);
    this.removepolyline();
  }
  componentDidMount() {
    this.onScriptLoad(this.state.mapType);

    if (socket === false) {
      this.socketUpdateData();
    } else {
      this.socket.disconnect();
      this.socketUpdateData();
    }

    if (messaging !== null) {
      messaging
        .requestPermission()
        .then(async function () {
          const token = await messaging.getToken();

          let data = {
            key: token,
          };
          let req = {
            method: "post",
            url: config.baseUrl + "api/v1/clients/notifications/subscribe",
            headers: {
              Authorization: "Bearer " + config.token,
            },
            data: data,
          };
          axios(req)
            .then((resp) => {
              if (resp.data.status === 1) {
              }
            })
            .catch((err) => {});
        })
        .catch(function (err) {
          console.log("Unable to get permission to notify.", err);
        });
      if (typeof navigator !== "undefined" && navigator.serviceWorker) {
        navigator.serviceWorker.addEventListener("message", (message) =>
          console.log(message)
        );
      }
    }
  }

  render() {
    const shortcuts = {
      امروز: moment(),
      دیروز: moment().subtract(1, "days"),
    };

    return (
      <div>
        <Loading loading={this.state.loading} />
        {this.state.signout ? <Redirect to="/login" /> : ""}
        <div id={"myMap"} className="Map col-lg-12 col-md-12" />
        <button
          className={`map-btn ${
            this.state.isInfoBoxOpen !== 0
              ? "map-btn1"
              : this.state.showStopDiv
              ? "map-btn4"
              : ""
          }`}
          onClick={() => this.setState({ trackerListIsOpen: true })}
        >
          <i className="icon-signal" />
        </button>
        <button
          className={`map-btn ${
            this.state.isInfoBoxOpen !== 0
              ? "map-btn2"
              : this.state.showStopDiv
              ? "map-btn5"
              : ""
          }`}
          style={{ bottom: "70px" }}
          onClick={() => this.setState({ mapTypesListIsOpen: true })}
        >
          <i className="icon-world" />
        </button>
        <button
          className={`map-btn ${
            this.state.isInfoBoxOpen !== 0
              ? "map-btn3"
              : this.state.showStopDiv
              ? "map-btn6"
              : ""
          }`}
          style={{ bottom: "120px" }}
          onClick={this.reloadMap}
          title="بارگذاری مجدد نقشه"
        >
          <i className="icon-mapRefresh" />
        </button>
        <button
          className={`map-btn ${
            this.state.isInfoBoxOpen !== 0
              ? "map-btn8"
              : this.state.showStopDiv
              ? "map-btn10"
              : ""
          }`}
          style={{ bottom: "170px" }}
          onClick={this.zoomOut}
          title="کوچک‌نمایی"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#3D8DF9"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{ display: "inline-block", verticalAlign: "middle", marginTop: "3px" }}
          >
            <line x1="5" y1="12" x2="19" y2="12" />
          </svg>
        </button>
        <button
          className={`map-btn ${
            this.state.isInfoBoxOpen !== 0
              ? "map-btn7"
              : this.state.showStopDiv
              ? "map-btn9"
              : ""
          }`}
          style={{ bottom: "220px" }}
          onClick={this.zoomIn}
          title="بزرگ‌نمایی"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#3D8DF9"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{ display: "inline-block", verticalAlign: "middle", marginTop: "3px" }}
          >
            <line x1="12" y1="5" x2="12" y2="19" />
            <line x1="5" y1="12" x2="19" y2="12" />
          </svg>
        </button>
        <Modal
          isOpen={this.state.trackerListIsOpen}
          onRequestClose={this.closeTrackerList}
          style={{
            content: { top: "calc(100vh / 5)", left: "40%", right: "40%" },
          }}
        >
          <p>ردیاب ها</p>
          <ul>
            {this.state.trackerList.length > 0 ? (
              this.state.trackerList.map((key) => (
                <li key={key[0]}>
                  <button onClick={() => this.handleCheckbox(key[0])}>
                    <img
                      src={require(`../../image/Ellipse-${
                        this.state.trackerChecked.includes(key[0]) ? "1" : "0"
                      }@2x.png`)}
                    />
                    <p>{key[1]}</p>
                    <span className="checkbox">
                      <img
                        src={require(`../../image/${
                          this.state.trackerChecked.includes(key[0])
                            ? "checked"
                            : "uncheck"
                        }.svg`)}
                      />
                    </span>
                  </button>
                </li>
              ))
            ) : (
              <p>ردیابی موجود نیست!</p>
            )}
          </ul>
        </Modal>
        <Modal
          isOpen={this.state.mapTypesListIsOpen}
          onRequestClose={this.closeMapTypsList}
          style={{
            content: { top: "calc(100vh / 5)", left: "40%", right: "40%" },
          }}
        >
          <p>نقشه ها</p>
          <ul>
            {isNeshan ? (
              <>
                <li>
                  <button onClick={() => this.chanegMapType("neshanVector")}>
                    <img
                      src={require(`../../image/Ellipse-${
                        this.state.mapType === "neshanVector" ? "1" : "0"
                      }@2x.png`)}
                      alt="نقشه نشان وکتور"
                    />
                    <p>نقشه نشان (وکتور)</p>
                    <span className="radio">
                      <img
                        src={require(`../../image/radio${
                          this.state.mapType === "neshanVector" ? "S" : "U"
                        }.png`)}
                        alt="انتخاب"
                      />
                    </span>
                  </button>
                </li>
                <li>
                  <button onClick={() => this.chanegMapType("neshanRaster")}>
                    <img
                      src={require(`../../image/Ellipse-${
                        this.state.mapType === "neshanRaster" ? "1" : "0"
                      }@2x.png`)}
                      alt="نقشه نشان رستر"
                    />
                    <p>نقشه نشان (رستر)</p>
                    <span className="radio">
                      <img
                        src={require(`../../image/radio${
                          this.state.mapType === "neshanRaster" ? "S" : "U"
                        }.png`)}
                        alt="انتخاب"
                      />
                    </span>
                  </button>
                </li>
              </>
            ) : (
              <li>
                <button onClick={() => this.chanegMapType("osm")}>
                  <img
                    src={require(`../../image/Ellipse-${
                      this.state.mapType === "osm" ? "1" : "0"
                    }@2x.png`)}
                    alt="نقشه OpenStreetMap"
                  />
                  <p>نقشه OpenStreetMap</p>
                  <span className="radio">
                    <img
                      src={require(`../../image/radio${
                        this.state.mapType === "osm" ? "S" : "U"
                      }.png`)}
                      alt="انتخاب"
                    />
                  </span>
                </button>
              </li>
            )}
          </ul>
        </Modal>
        <Modal
          isOpen={this.state.isTimeSelectOpen}
          onRequestClose={this.closeTimeSelect}
          style={{
            content: { top: "calc(100vh / 7)", left: "40%", right: "40%" },
          }}
        >
          <div className="title">
            <p>انتخاب بازه زمانی</p>
          </div>
          <ul>
            <li>
              <button
                onClick={() => {
                  this.handleSelectTime(1);
                }}
              >
                <p>یک ساعت گذشته</p>
                <span className="radio">
                  <img
                    src={require(`../../image/radio${
                      this.state.selectedTime === 1 ? "S" : "U"
                    }.png`)}
                  />
                </span>
              </button>
            </li>
            <li>
              <button
                onClick={() => {
                  this.handleSelectTime(6);
                }}
              >
                <p>شش ساعت گذشته</p>
                <span className="radio">
                  <img
                    src={require(`../../image/radio${
                      this.state.selectedTime === 6 ? "S" : "U"
                    }.png`)}
                  />
                </span>
              </button>
            </li>
            <li>
              <button
                onClick={() => {
                  this.handleSelectTime(12);
                }}
              >
                <p>دوازده ساعت گذشته</p>
                <span className="radio">
                  <img
                    src={require(`../../image/radio${
                      this.state.selectedTime === 12 ? "S" : "U"
                    }.png`)}
                  />
                </span>
              </button>
            </li>
            <li>
              <button
                onClick={() => {
                  this.handleSelectTime(24);
                }}
              >
                <p>بیست و چهار ساعت گذشته</p>
                <span className="radio">
                  <img
                    src={require(`../../image/radio${
                      this.state.selectedTime === 24 ? "S" : "U"
                    }.png`)}
                  />
                </span>
              </button>
            </li>
          </ul>
          <div className="time-div">
            <div className="right">
              <label>از تاریخ</label>
              <DatetimePickerTrigger
                shortcuts={shortcuts}
                moment={this.state.from}
                onChange={this.handleFromDate}
                showTimePicker={false}
                position="top"
                lang="fa"
                isSolar={true}
              >
                <input
                  className="date-input"
                  type="text"
                  value={this.state.from.format("jYYYY/jMM/jDD")}
                  readOnly
                />
              </DatetimePickerTrigger>
            </div>
            <div className="left">
              <label>تا تاریخ</label>
              <DatetimePickerTrigger
                shortcuts={shortcuts}
                moment={this.state.to}
                onChange={this.handleToDate}
                showTimePicker={false}
                position="top"
                lang="fa"
                isSolar={true}
              >
                <input
                  className="date-input"
                  type="text"
                  value={this.state.to.format("jYYYY/jMM/jDD")}
                  readOnly
                />
              </DatetimePickerTrigger>
            </div>
          </div>
          <div className="time-div" style={{ marginBottom: "0px" }}>
            <div className="right">
              <label>از ساعت</label>
              <TimePicker
                showSecond={false}
                className="time-input"
                defaultValue={this.state.from}
                onChange={this.handleFromDate}
              />
            </div>
            <div className="left">
              <label>تا ساعت</label>
              <TimePicker
                showSecond={false}
                className="time-input"
                defaultValue={this.state.to}
                onChange={this.handleToDate}
              />
            </div>
          </div>
          <div
            className="remindDiv"
            onClick={() => {
              this.setState({ showPoints: !this.state.showPoints });
            }}
          >
            <span className="checkbox">
              <img
                src={require(`../../image/${
                  this.state.showPoints === true ? "checked" : "uncheck"
                }.svg`)}
              />
            </span>
            <p className="blue" style={{ color: "#000" }}>
              نمایش مارکر ها
            </p>
          </div>
          <button className="blueBtn btn" onClick={this.getLocationReport}>
            دریافت سابقه
          </button>
          <button
            className="pinkBtn btn"
            onClick={this.closeTimeSelect}
            style={{ marginRight: "10px", padding: "15px 25px" }}
          >
            انصراف
          </button>
        </Modal>
        <Modal
          isOpen={this.state.isAnimationSpeedOpen}
          onRequestClose={this.closeAnimationSpeed}
          style={{
            content: { top: "calc(100vh / 5)", left: "40%", right: "40%" },
          }}
        >
          <div className="title">
            <p>سرعت انیمیشن</p>
          </div>
          <div>
            <span className="circle">{this.state.value}</span>
            <div className="range-div">
              <span
                className={`step ${this.state.value >= 1 ? "blue" : ""}`}
                style={{ left: "0.5%" }}
              />
              <span
                className={`step ${this.state.value >= 2 ? "blue" : ""}`}
                style={{ left: "10.5%" }}
              />
              <span
                className={`step ${this.state.value >= 3 ? "blue" : ""}`}
                style={{ left: "20.5%" }}
              />
              <span
                className={`step ${this.state.value >= 4 ? "blue" : ""}`}
                style={{ left: "30.5%" }}
              />
              <span
                className={`step ${this.state.value >= 5 ? "blue" : ""}`}
                style={{ left: "40.5%" }}
              />
              <span
                className={`step ${this.state.value >= 6 ? "blue" : ""}`}
                style={{ left: "50.5%" }}
              />
              <span
                className={`step ${this.state.value >= 7 ? "blue" : ""}`}
                style={{ left: "60.5%" }}
              />
              <span
                className={`step ${this.state.value >= 8 ? "blue" : ""}`}
                style={{ left: "70.5%" }}
              />
              <span
                className={`step ${this.state.value >= 9 ? "blue" : ""}`}
                style={{ left: "80.5%" }}
              />
              <span
                className={`step ${this.state.value >= 10 ? "blue" : ""}`}
                style={{ right: "3%" }}
              />
              <input
                type="range"
                min={1}
                max={10}
                step={1}
                className="slider"
                onChange={this.handleRangeSpeed}
                value={this.state.value}
              />
            </div>
          </div>
          <button
            className="blueBtn btn"
            style={{ padding: "15px 60px" }}
            onClick={this.startAnimate}
          >
            شروع
          </button>
          <button
            className="pinkBtn btn"
            style={{ marginRight: "10px", padding: "15px 25px" }}
            onClick={this.closeAnimationSpeed}
          >
            انصراف
          </button>
        </Modal>
        <Modal
          isOpen={this.state.isExpiredTracersOpen}
          onRequestClose={() => {
            this.setState({ isExpiredTracersOpen: false });
          }}
          style={{
            content: { top: "calc(100vh / 5)", left: "35%", right: "35%" },
          }}
        >
          <div className="title">
            <p>اتمام شارژ سالیانه سامانه ردیاب</p>
          </div>

          <p style={{ fontSize: "13px", textAlign: "center" }}>
            شارژ سالیانه سامانه ردیاب های زیر به پایان رسیده است، به منظور
            استفاده از امکانات سامانه، لطفا در اولین فرصت اقدام به پرداخت
            نمایید!
          </p>

          <ul className="expiredTracers">
            {this.state.expiredTracers.map((key) => (
              <li>
                <div>
                  <label>عنوان ردیاب: </label>
                  <b>{key.title ? key.title : "بدون عنوان"}</b>
                </div>

                <div>
                  <label>تاریخ انقضا: </label>
                  <b>{moment(key.expires_at).format("jYYYY/jMM/jDD")}</b>
                </div>
              </li>
            ))}
          </ul>

          <a
            href={`http://irgogps.com/payment/?token=${config.token}`}
            target="blank"
          >
            <button className="blueBtn btn" style={{ padding: "15px 95px" }}>
              پرداخت
            </button>
          </a>
          <button
            className="pinkBtn btn"
            style={{ marginRight: "10px", padding: "15px 55px" }}
            onClick={() => {
              this.setState({ isExpiredTracersOpen: false });
            }}
          >
            انصراف
          </button>
        </Modal>
        <div
          className={"infoBox"}
          style={{
            display:
              this.state.isInfoBoxOpen !== 0 &&
              (this.state.showPlayIcon === false ||
                this.state.showStopDiv === false)
                ? "block"
                : "none",
          }}
        >
          <button
            className="closePolyline"
            style={{ top: "7px" }}
            onClick={() => {
              this.setState({ isInfoBoxOpen: 0 });
            }}
          >
            بستن
          </button>
          <div className="infoHeader">
            <div className="right">
              <img src={require("../../image/Ellipse-2@2x.png")} />
              <p>{this.state.trackerData && this.state.trackerData.title}</p>
            </div>
            <div className="left">
              <a
                href={this.state.trackerData ? `https://www.google.com/maps/dir/?api=1&travelmode=driving&destination=${this.state.trackerData.last_lat},${this.state.trackerData.last_lng}` : "#"}
                target="blank"
              >
                <p>من تا خودرو</p>
              </a>
              <button>
                <i className="icon-share" />
              </button>
            </div>
          </div>
          <div className="infoContent">
            <div className="right">
              <button
                onClick={() => {
                  this.setState({ isTimeSelectOpen: true });
                }}
              >
                <i className="icon-time" />
                <p>سابقه موقعیت</p>
              </button>
            </div>
            <div className="left">
              <div className="right">
                <div>
                  <i className="icon-save" />
                  <p>
                    {this.state.trackerData && this.state.trackerData.last_sent
                      ? moment(this.state.trackerData.last_sent).format(
                          "jYYYY/jMM/jDD | HH:mm"
                        )
                      : ""}
                  </p>
                </div>
                <div>
                  <i className="icon-speed" />
                  <p>{(this.state.trackerData && this.state.trackerData.last_speed) || 0} کیلومتر بر ساعت</p>
                </div>
              </div>
              <div className="left">
                <div>
                  <i className="icon-motor" />
                  <p>
                    {(this.state.trackerData && this.state.trackerData.last_acc === 0) ? "خاموش" : "روشن"}
                  </p>
                </div>
                <div>
                  <i className="icon-radar" />
                  <p>
                    {(!this.state.trackerData || !this.state.trackerData.last_sat_count)
                      ? 0
                      : this.state.trackerData.last_sat_count}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="stop-div"
          style={{ display: this.state.showStopDiv ? "block" : "none" }}
        >
          <p className="time">
            {this.state.currentLocReport && this.state.currentLocReport.sent_at
              ? moment(this.state.currentLocReport.sent_at).format(
                  "jYYYY/jMM/jDD | HH:mm"
                )
              : ""}
          </p>
          <button className="closePolyline" onClick={this.removepolyline}>
            بستن
          </button>
          <div>
            <h5>
              {this.state.currentLocReport && this.state.currentLocReport.total_distance != null
                ? parseFloat(this.state.currentLocReport.total_distance / 1000).toFixed(1)
                : 0}{" "}
              کیلو متر
            </h5>
            <p>مسافت طی شده</p>
          </div>
          <div>
            {this.state.isPause ? (
              <button
                className="stop"
                style={{ backgroundColor: "rgba(61, 141, 249, 0.15)" }}
                onClick={() => {
                  this.setState({ isAnimationSpeedOpen: true });
                }}
              >
                <i className="icon-play" />
              </button>
            ) : (
              <button className="stop" onClick={this.stopAnimate}>
                <i className="icon-pause" />
              </button>
            )}
          </div>
          <div>
            <h5>km/h {(this.state.currentLocReport && this.state.currentLocReport.speed) || 0}</h5>
            <p>سرعت</p>
          </div>
        </div>
        <button
          className="play"
          style={{ display: this.state.showPlayIcon ? "block" : "none" }}
          onClick={() => {
            this.setState({
              isAnimationSpeedOpen: true,
              showPlayIcon: false,
            });
          }}
        >
          <i className="icon-play" />
        </button>
      </div>
    );
  }
}
export default  withAlert(MainMap);
